import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  panel: {
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2)
  },
  finding: {
    marginTop: theme.spacing(1)
  },
  explanation: {
    opacity: 0.85
  }
}))

export default useStyles
